var defaultTxt = jQuery(
  ".template-search .toolbar-dropdown .label-tab [name='paginateBy']"
).text();
var lengthPro = document.querySelectorAll(
  ".template-search ul#main-collection-product-grid li.product"
).length;
var removeSpace = defaultTxt.replace(/\s/g, "");
var activeVal = jQuery(
  ".template-search .toolbar-dropdown li.is-active span"
).text();
//console.log(activeVal);
// Check if removeSpace is empty and update the text in the element
if (removeSpace != "") {
  jQuery(
    ".template-search .toolbar-dropdown .label-tab [name='paginateBy']"
  ).text(activeVal);
  // console.log(activeVal);
} else {
  jQuery(
    ".template-search .toolbar-dropdown .label-tab [name='paginateBy']"
  ).text(lengthPro);
}

document.addEventListener("DOMContentLoaded", function () {
  var query = new URLSearchParams(window.location.search);
  var sortBy = query.get("sort_by") || "relevance"; // Default to 'relevance' if not set

  var labelElement = document.querySelector(
    ".toolbar-sort .label-tab .label-text"
  );
  var sortOptions = {
    relevance: "Relevance",
    "price-ascending": "Price low to high",
    "price-descending": "Price hight to low",
  };

  document
    .querySelectorAll(".template-search .dropdown-menu .text")
    .forEach(function (item) {
      item.addEventListener("click", function () {
        var selectedSortBy = this.getAttribute("data-value");
        query.set("sort_by", selectedSortBy);
        window.location.search + query.toString();
      });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  var header = document.querySelector(".page-header");
  if (header) {
    header.innerHTML = header.innerHTML.replace(
      /“([^“”]+)”/g,
      '<span class="highlighted-word">$1</span>'
    );
  }
});

jQuery(
  "#halo-image-banner-template--18710123446591__55488a26-c102-4e47-a917-f3a7fd6bfc20 .item-template--18710123446591__55488a26-c102-4e47-a917-f3a7fd6bfc20-1681998586104545ca-0 .banner-button"
).click(function () {
  jQuery("html, body").animate(
    {
      scrollTop: jQuery("#form").offset().top - 160,
    },
    500
  );
});

jQuery(".see_all_reviews_title_product a").click(function () {
  jQuery("html, body").animate(
    {
      scrollTop:
        jQuery(
          "#shopify-section-template--17328138649919__4b6fbb36-9486-4936-b1ee-c56a9aa43560"
        ).offset().top - 60,
    },
    500
  );
});

jQuery(
  "#shopify-section-template--22371899834687__b4558760-147d-4ddb-bc47-912bf6333929 a"
).click(function () {
  jQuery("html, body").animate(
    {
      scrollTop:
        jQuery(
          "#shopify-section-template--22371899834687__custom_text_block_dWhmdG"
        ).offset().top - 15,
    },
    1000
  );
});

function addProductToCart() {
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: jQuery('input[name="id"]').val(),
      quantity: 1,
      properties: {
        "Screen Size": jQuery(".screen_size").val(),
      },
    },
    success: function (data) {
      //console.log("Product added to cart successfully!");
    },
    error: function (XMLHttpRequest, textStatus) {
      // console.log("Error adding product to cart.");
    },
  });
}
function openInstallmentModal() {
  // console.log("Modal Function Is Called");
  jQuery("#payment_installment").addClass("modal-open-box-open");
}

function closeInstallmentModal() {
  jQuery(".modal-open-box-open").removeClass("modal-open-box-open");
}
jQuery(".tabby_product_sop_sect a").click(function () {
  openInstallmentModal();
});
const menuBtn = document.querySelector(".question-menu-btn");
const menu = document.querySelector(".question-menu");
const menuClose = document.querySelector(".question-menu-close");

let menuOpen = false;
if (menuBtn !== undefined && menuBtn !== null) {
  menuBtn.addEventListener("click", () => {
    if (!menuOpen) {
      menuBtn.classList.add("open");
      menu.classList.add("active");
      menuOpen = true;
    } else {
      menuBtn.classList.remove("open");
      menu.classList.remove("active");
      menuOpen = false;
    }
  });

  menuClose.addEventListener("click", () => {
    menuBtn.classList.remove("open");
    menu.classList.remove("active");
    menuOpen = false;
  });
}

let variantInput = document.getElementById("SelectedVariantId");
if (variantInput) {
    variantInput.addEventListener("change", function () {
        let newValue = this.value;
        document.querySelectorAll(".sticky_variant_id").forEach(element => {
            element.value = newValue;
        });
    });
}

//// set condition price function/////
function set_condition_price() {
  var stickyBtns = document.querySelectorAll("#product-sticky-add-to-cart");
  var variantOptions = document.querySelector(".product-details variant-radios.product-option");
  var currentUrl = window.location.href;
  if (currentUrl.includes("products/")) {
    if (bcpo_product && bcpo_product.variants !== undefined) {
      setTimeout(function () {
        var objects = bcpo_product.variants;
       // jQuery(".variant-price-in-box").html("-");
        var array = {};

        jQuery(".form__label").each(function () {
          var legendText = $(this).text().trim();
          var label = legendText.split(/[\s:]+/)[0].toLowerCase();
          
          if (label !== "choose") {
            if (
              label.includes("??") ||
              label.includes("?") ||
              label.includes("لون")
            ) {
              label = "color";
            } else if (
              label.includes("تخزين") ||
              label.includes("storage/ram") ||
              label.includes("حجم") ||
              label.includes("controller") ||
              label.includes("جهاز")
            ) {
              label = "storage";
            }
            if (
              label === "الحجم" ||
              label === "سعة الذاكرة" ||
              label === "سعة" ||
              label == "includes" ||
              label == "يتضمن" ||
              label.includes("ذاكرة")
            ) {
              label = "storage";
            }

            if (label == "حالة" || label == "الحالة") {
              label = "condition";
            }
            var value = jQuery(this)
              .find("span[data-header-option]")
              .text()
              .trim();
            value = value.replace(/\s+/g, " "); // Replaces multiple spaces with a single space

            array[label] = value;
          }
        });
        //console.log("Current Array options:", array);
        if (array["condition"] == "New" || array["condition"] == "جديد") {
          $(".pprice-condition-embed").hide();
        } else {
          $(".pprice-condition-embed").show();
        }
        for (var i = 0; i < objects.length; i++) {
          var object = objects[i];
          var option2 = object.option2.trim();
          // console.log("My option 2",option2);
          var formattedPrice =
            global_currency + " " + (object.price / 100).toFixed(0);
          var simplePrice = (object.price / 100).toFixed(0);
          // Case 1: Match color and storage
          if (object.option1 == array["color"] && option2 == array["storage"]) {
            // console.log("WholeObject",object);
            // console.log("step 1..");
            var $input = $(
              'input.product-form__radio[value="' + object.option3 + '"]'
            );
            var $label = $('label[for="' + $input.attr("id") + '"]');
            var $span = $label.find("span.text .variant-price-in-box");
            if ($span.length > 0) {
              if (!$label.hasClass("soldout")) {
              if(simplePrice > 0){
                $span.html(formattedPrice); 
              }}

              if (object.option3 == "New") {
                //    console.log("New Price Is ",simplePrice);
              }

              $(".productView-hotStock").show();
            } else {
              //    console.log("No matching input found for storage option3:", object.option3);
            }
          }


          // Case 1: Match Storage and ram

          if (object.option1 == array["storage"] && option2 == array["ram"]) {
            // console.log("WholeObject",object);
            // console.log("step 1..");
            var $input = $(
              'input.product-form__radio[value="' + object.option3 + '"]'
            );
            var $label = $('label[for="' + $input.attr("id") + '"]');
            var $span = $label.find("span.text .variant-price-in-box");
            if ($span.length > 0) {
               if (!$label.hasClass("soldout")) {
              if(simplePrice > 0){
                $span.html(formattedPrice); 
              }
            }
              //   console.log("Price appended for storage variant:", object.option3);

              if (object.option3 == "New") {
                //    console.log("New Price Is ",simplePrice);
              }

              $(".productView-hotStock").show();
            } else {
              //    console.log("No matching input found for storage option3:", object.option3);
            }
          }


            
          // Case 2: Match color and condition
          else if (
            (object.option1 == array["color"] &&
            option2 == array["condition"] ) || 
            (object.option1 == array["speaker"] &&
            option2 == array["condition"] )
          ) {
            // console.log("step 2..");
            // console.log("WholeObject",object);

            var $inputCondition = $(
              'input.product-form__radio[value="' + object.option2 + '"]'
            );
            var $labelCondition = $(
              'label[for="' + $inputCondition.attr("id") + '"]'
            );
            var $spanCondition = $labelCondition.find(
              "span.text .variant-price-in-box"
            );
            if ($spanCondition.length > 0) {
              $spanCondition.html(formattedPrice);
              $(".productView-hotStock").show();
              // console.log("Price appended for condition variant:", object.option2);
            } else {
              $(".productView-hotStock").show();
              // console.log("Not Found:", object.option2);
            }
          }

          // handle only one option : color
          else if (object.option1 == array["color"] || object.option1 == array["speaker"]) {
            var $inputCondition = $(
              'input.product-form__radio[value="' + object.option2 + '"]'
            );
            var $labelCondition = $(
              'label[for="' + $inputCondition.attr("id") + '"]'
            );
            var $spanCondition = $labelCondition.find(
              "span.text .variant-price-in-box"
            );
            if ($spanCondition.length > 0) {
              $spanCondition.html(formattedPrice);
              $(".productView-hotStock").show();
              // console.log("Price appended for condition variant:", object.option2);
            } else {
              $(".productView-hotStock").show();
              // console.log("Not Found:", object.option2);
            }
          }




          // end handle only one option : color
        }

        /*
		Commented by Ali - Laptop should be handled in the same forloop - its causing first loop to run completely and for laptops it runs again
        if (bcpo_product.type.includes("Laptop")) {
          for (var i = 0; i < objects.length; i++) {
            var object = objects[i];
            var option2 = object.option2;
            var formattedPrice =
              global_currency + " " + (object.price / 100).toFixed(0);
            //  console.log("Objects",option2);
            if (object.option1 == array["storage"] && option2 == array["ram"]) {
              //  console.log("WholeObject",object);

              var $input = $(
                'input.product-form__radio[value="' + object.option3 + '"]'
              );
              var $label = $('label[for="' + $input.attr("id") + '"]');
              var $span = $label.find("span.text .variant-price-in-box");
              if ($span.length > 0) {
                $span.html(formattedPrice);
                $(".productView-hotStock").show();
              } else {
              }
            }
          }
        }*/

        /*
		Commented by Ali as no discounted html exisit anymore
        var discountedPriceHTML = Math.round(
          (parseInt(
            $(".productView-price .price-item--sale")
              .html()
              .replace(global_currency, "")
              .replace(/,/g, ""),
            10
          ) *
            1.0) /
            3
        );
        var customDividePrices = document.querySelectorAll(
          ".custom_divide_price"
        );
        if (discountedPriceHTML) {
          customDividePrices.forEach(function (div) {
            div.innerHTML = global_currency + " " + discountedPriceHTML;
          });
        }*/

        /*
		Commented by Ali for low priority widgets
        checkBlackFridayVariants();
        checkLeastPrice();
        set_bestDeal();
        */
        checkBlackFridayVariants();
        callUpdateStickyPrice();
        fbrVariantTagSticky();

        var current_variant_id = jQuery(
          'form.installment input[name="id"]'
        ).val();
        if (global_suppliers_data_module == "true" && !window.customSupplierHandlerActive) {
          updateVariantSupplier(current_variant_id);
        }
        var current_product_price = parseFloat(
          $(".productView-price .price-item--sale")
            .html()
            .replace(new RegExp(global_currency + "\\s*|,", "g"), "")
        );
        setWarrantyAttributes();
        adjusttabbytamaraprices();
        //updateLabelVisibility();
        if (current_product_price === 0) {
          $(".productView-price").hide();
          $(".productView-hotStock").removeClass("hidden");
          $(".productView-hotStock").hide();
        } else {
          $(".productView-price").show();
          $(".productView-hotStock").addClass("hidden");
          $(".productView-hotStock").show();
        }
      }, 800);
    }
  }
}
/////////////////////////
function callUpdateStickyPrice() {
  var templateName = document.getElementById('templateName').value;
if(templateName.includes('premium') || templateName.includes('product-laptop-template') || templateName.includes('product-esim') || templateName.includes('product-ipad-template'))
  {
    return false;
  }
  
  var current_product_price = parseFloat(
  ($(".productView-price .price-item--sale").text() || "")
    .replace(/\u00A0/g, " ") // normalize &nbsp;
    .trim()
    .replace(/[^\d.]/g, "") // keep only digits and dot
  );
  updateStickyPrice(current_product_price);
}

function updateStickyPrice(basePrice) {
  
  const warrantyPrice = setWarrantyPrice(basePrice);
  const isWarrantyChecked = $(
    ".price.warranty__price input#add_extended_warranty"
  ).prop("checked");

  const crossSaleTotal = Array.from(
    document.querySelectorAll('input[name="cross-sale"]:checked')
  ).reduce((total, crossSaleProduct) => {
    const parentDiv = crossSaleProduct.closest(".cross-sale-checkbox");
    const dataPrice = parentDiv
      ? parseFloat(parentDiv.getAttribute("data-price") || 0)
      : 0;
    return total + dataPrice;
  }, 0);
let finalPrice;
if (isWarrantyChecked) {
  finalPrice = basePrice + crossSaleTotal + warrantyPrice;
} else {
  finalPrice = basePrice + crossSaleTotal;
}

  // add cashback condition to total amount
  var modifyCashBackOrWhiteFridayClass = document.querySelector( ".sticky-product-wrapper" );
  const shouldEnable =
    (global_store === "uae" && finalPrice >= 1000) ||
    (global_store === "ksa" && finalPrice >= 1000) ||
    (global_store === "ksa-virgin" && finalPrice >= 1000) ||
    (global_store === "za" && finalPrice >= 5000);

  // Toggle on the main container (if it exists)
  if (typeof modifyCashBackOrWhiteFridayClass !== "undefined" && modifyCashBackOrWhiteFridayClass) {
    modifyCashBackOrWhiteFridayClass.classList.toggle("enable-cash-back-deal-sticky-pdp", shouldEnable);
  }
  // end - Add cashback condition

  finalPrice = formatPrice(finalPrice);

  const currentVariantPriceElement = document.querySelector(
    ".halo-productView-right .productView-price .price__sale .price__last .price-item"
  );




  
  const currentVariantComparePriceElement = document.querySelector(
    ".productView-price .price.price--medium dd.price__compare s.price-item.price-item--regular"
  );
  const currentVariantCompareConditionElement = document.querySelector(
    ".productView-price .price.price--medium dd.price__compare span.product-condition.pprice-condition-embed"
  );

  const currentVariantPrice = currentVariantPriceElement?.textContent || "";




//console.log("Pprices Are",isWarrantyChecked,basePrice,warrantyPrice,currentVariantPrice,finalPrice);


  const currentVariantComparePrice = currentVariantComparePriceElement
    ? parseFloat(
      String(currentVariantComparePriceElement.textContent || "")
        .replace(/\u00A0/g, " ")   // normalize &nbsp;
        .trim()
        .replace(/[^\d.]/g, "")    // keep only digits + dot
    ) || 0
    : 0;

  let updatedComparePrice = "";
  if (currentVariantComparePrice) {
    updatedComparePrice = formatPrice(
      currentVariantComparePrice + crossSaleTotal
    );
  }

  const currentVariantCompareCondition = updatedComparePrice
    ? currentVariantCompareConditionElement?.textContent || ""
    : "";

  const finalPriceNum = parseFloat(
    String(finalPrice || "")
      .replace(/\u00A0/g, " ")   // remove non-breaking spaces
      .trim()
      .replace(/[^\d.]/g, "")    // keep only digits + dot
  );
  //const finalPriceNum = parseFloat(finalPrice.replace(new RegExp(global_currency + "\\s*|,", "g"), ""));
 let ncurrentVariantPrice =  parseFloat(
    String(finalPrice || "")
      .replace(/\u00A0/g, " ")   // remove non-breaking spaces
      .trim()
      .replace(/[^\d.]/g, "")    // keep only digits + dot
  );

    const finalPriceNum2 = ncurrentVariantPrice;


  const discountPercent = Math.round( ((currentVariantComparePrice - finalPriceNum2) / currentVariantComparePrice) * 100 );

  // Update DOM elements
  const stickyPricing = document.querySelector(
    ".pdp-sticky-special-campaign-pricing"
  );
  if (stickyPricing) {
    stickyPricing.querySelector("span.pdp-sticky-special-campaign-discounted-price").textContent = finalPriceNum > 0 ? finalPrice : "";
    stickyPricing.querySelector("span.pdp-sticky-special-campaign-compare-price").textContent = finalPriceNum < currentVariantComparePrice ? updatedComparePrice : "";
    stickyPricing.querySelector("span.pdp-sticky-special-campaign-condition").textContent = finalPriceNum < currentVariantComparePrice ? currentVariantCompareCondition : "";
    stickyPricing.querySelector("span.pdp-sticky-spec-cam-compare-price-wrapper").style.display = finalPriceNum < currentVariantComparePrice && finalPriceNum > 0 ? "block" : "none";
    stickyPricing.querySelector("span.pdp-sticky-spec-cam-compare-badge").textContent = finalPriceNum < currentVariantComparePrice && finalPriceNum > 0 ? `-${discountPercent}%` : "";
    // document.querySelector(".productView-image-wrapper .halo-productBadges .badge.sale-badge .pdp-discounted-percentage").textContent = finalPriceNum < currentVariantComparePrice && finalPriceNum > 0 ? `-${discountPercent}%` : "";
    const discountBadge = document.querySelector(".productView-image-wrapper .halo-productBadges .badge.sale-badge .pdp-discounted-percentage");

    if (discountBadge) {

// console.log("ncurrentVariantPrice:", ncurrentVariantPrice);
// console.log("currentVariantComparePrice:", currentVariantComparePrice);
// console.log("discountPercent:", discountPercent);
// console.log(
//   "Condition Result:",
//   ncurrentVariantPrice < currentVariantComparePrice && ncurrentVariantPrice > 0
// );

const discountText =
  ncurrentVariantPrice < currentVariantComparePrice && ncurrentVariantPrice > 0
    ? `-${discountPercent}%`
    : "";

      discountBadge.textContent = discountText;
    }
  }
}

function formatPrice(price) {
  let formattedPrice = global_currency + " " + price.toLocaleString();
  return formattedPrice;
}

function isMobile() {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
}

var currentUrl = window.location.href;
var pageName = currentUrl.substring(currentUrl.lastIndexOf("/") + 1);
if (pageName == "b2b-offers") {
  var submitOrderRequestAnchor = document.querySelector(".banner-button");

  // Check if the anchor tag is found
  if (submitOrderRequestAnchor) {
    // Change the href attribute of the anchor tag
    submitOrderRequestAnchor.href = "#order-request";
  }
}

jQuery(".predictive-search__results-list .card-media img").click(function () {
  jQuery(this).parent(".card-media").trigger("click");
});

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function openCategoriesNav() {
  var catNav = document.querySelector(".mobileMenu-toggle");
  catNav.click();
}

jQuery(".tamara_shop_now_link").click(function () {
  jQuery(".main_product_add_to_cart_form").trigger("submit");
});

jQuery(".tabby_shop_now_link").click(function () {
  jQuery(".main_product_add_to_cart_form").trigger("submit");
});

function check_quick_delivery() {
  $(".qd-Condition").hide();
  // Get all elements with the class "product-form__radio"
  const radioButtons = document.querySelectorAll(".product-form__radio");

  // Loop through each radio button
  radioButtons.forEach((radioButton) => {
    // Check if the radio button is checked
    if (radioButton.checked) {
      // Retrieve the value of the name attribute
      const nameAttribute = radioButton.getAttribute("name");
      // Retrieve the value of the data-variant-id attribute
      const variantId = radioButton.getAttribute("data-variant-id");

      // Check if the name attribute is "Storage"
      if (nameAttribute === "Storage") {
        // Find the sibling element with class "product-form__label"
        const productFormLabel = radioButton.nextElementSibling;
        // Check if the sibling element exists and has a child element with class ".quick-delivery-${variantId}"
        if (
          productFormLabel &&
          productFormLabel.querySelector(`.quick-delivery-${variantId}`)
        ) {
          $(".qd-Condition.quick-delivery-" + variantId).show();
        }
      }
    }
  });
}
function removeSoldOutClassForValue(value) {
  // Find the input element with the specified value
  var inputElement = document.querySelector('input[value="' + value + '"]');
  if (inputElement) {
    // Remove the soldout class from the input element
   // inputElement.classList.remove("soldout");
   // inputElement.removeAttribute("disabled");

    // Find the corresponding label element
    var labelForInputElement = document.querySelector(
      'label[for="' + inputElement.id + '"]'
    );
    if (labelForInputElement) {
      // Remove the soldout class from the label element
      //labelForInputElement.classList.remove("soldout");
     // labelForInputElement.removeAttribute("disabled");
    }
  }
}

function removeSoldOutClassAndEnableVariant(variants, color, size) {
  // Loop through the array of variants
  for (var i = 0; i < variants.length; i++) {
    var variant = variants[i];

    // Check if the variant matches the specified color and size
    if (variant.option1 === color && variant.option2 === size) {
      // Find the input element with the corresponding variant ID
      var inputElement = document.querySelector(
        'input[value="' + variant.id + '"]'
      );
      if (inputElement) {
        // Remove the 'soldout' class and the 'disabled' attribute
       // inputElement.classList.remove("soldout");
       // inputElement.removeAttribute("disabled");

        // Find the corresponding label element
        var labelForInputElement = document.querySelector(
          'label[for="' + inputElement.id + '"]'
        );
        if (labelForInputElement) {
          // Remove the 'soldout' class and the 'disabled' attribute
         // labelForInputElement.classList.remove("soldout");
         // labelForInputElement.removeAttribute("disabled");
        }
      }
    }
  }
}



function batteryModalOpen() {
  var body = document.querySelector("body");
  body.classList.add("battery-sidebar-show");
  document.querySelector(".modal-protection-section").style.display = "block";
}

function closeBatteryModal() {
  var body = document.querySelector("body");
  body.classList.remove("battery-sidebar-show");
}

function openWarrantyDrawer(w_product_id, w_price, title) {
  if (title == "") {
    title = "Device";
  }
  var body = document.querySelector("body");
  body.classList.add("warranty-sidebar-show");
  document.querySelector("#halo-warranty-sidebar").style.display = "block";
  var lang = document.documentElement.lang;
  var title_id = "title_to_display_warranty";
  var title_id = "title_to_display_warranty_ar";
  if (lang == "en") {
    var title_id = "title_to_display_warranty";
  }

  document.getElementById(title_id).innerHTML = title;
}

function closeWarrantyDrawer() {
  var body = document.querySelector("body");
  body.classList.remove("warranty-sidebar-show");
}

document.addEventListener("click", function (event) {
  if (document.body.classList.contains("warranty-sidebar-show")) {
    if (!event.target.closest("#halo-warranty-sidebar")) {
      document.body.classList.remove("warranty-sidebar-show");
    }
  }
});

function showFbrVariantsPopup() {
  if (document.getElementById("showfbrvariants").checked) {
    //AddClasses();

    openFbrModal();
  } else {
    resetClasses();
  }
}

function openFbrModalSimple() {
  var body = document.querySelector("body");
  body.classList.add("delivery-sidebar-show");
}

function openFbrModal() {
  var body = document.querySelector("body");
  body.classList.add("delivery-sidebar-show");
  //AddClasses();
}

function removeFbrClass() {
  document.body.classList.remove("delivery-sidebar-show");
}

function openWarrantyModalSimple() {}
// function closeSideBar() {
//   var cartUrl = window.location.origin + "/cart";
//   if (document.documentElement.lang === "ar") {
//     cartUrl = window.location.origin + "/ar/cart";
//   }
//   location.href = cartUrl;

//   var sidebar = document.getElementById("halo-cart-sidebar");
//   if (sidebar) {
//     sidebar.classList.remove("halo-cart-sidebar-battery");
//   }
// }

function closeSideBar(baseCartPath = "/cart") {
  const lang = document.documentElement.lang;
  const cartPath = lang === "ar" ? `/${lang}${baseCartPath}` : baseCartPath;
  const cartUrl = window.location.origin + cartPath;

  location.href = cartUrl;

  const sidebar = document.getElementById("halo-cart-sidebar");
  if (sidebar) {
    sidebar.classList.remove("halo-cart-sidebar-battery");
  }
}

function checkFbrVariant(variant_id) {
  var fbr_variants = window.fbr_variants;
  if (variant_id in fbr_variants) {
    document.getElementById("fbbbr").value = "1";
  } else {
    document.getElementById("fbbbr").value = "0";
  }
}

function getProductPricingAgainForTabbyTamara() {
  if (document.querySelector(".recurpay__group_discounted_price")) {
    var discountedPriceHTML = document.querySelector(
      ".recurpay__group_discounted_price"
    ).innerHTML;

    var customDividePrices = document.querySelectorAll(".tabby_sec_price");
    if (discountedPriceHTML) {
      customDividePrices.forEach(function (div) {
        div.innerHTML = discountedPriceHTML;
      });
    }
  }
}

function getProductPricingAgainForTabbyTamaraForVariant() {
  if (document.querySelector(".recurpay__group_discounted_price")) {
    var discountedPriceHTML = document.querySelector(
      ".custom_divide_price"
    ).innerHTML;

    var customDividePrices = document.querySelectorAll(".tabby_sec_price");
    if (discountedPriceHTML) {
      customDividePrices.forEach(function (div) {
        div.innerHTML = discountedPriceHTML;
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var isRTL = document.documentElement.getAttribute("dir") === "rtl";
  var slickElement = document.querySelector(
    ".custom-testimonials-section .halo-row.column-3"
  );
  if (slickElement) {
    if (slickElement.classList.contains("slick-initialized")) {
      $(slickElement).slick("unslick");
    }
    $(slickElement).slick({
      infinite: true,
      arrows: false,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      rtl: isRTL,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
});

//////////////New Functions////////
function setWarrantyPrice(variant_price) {
  let warrantyPrice = 0;
  warranty_products.forEach((product) => {
    if (
      variant_price >= product.start_range &&
      variant_price < product.end_range
    ) {
      let warrantyPriceNum = Number(String(product.price).replace(/[^0-9.-]/g, ""));
      let warrantyPriceFormatted = Number.isFinite(warrantyPriceNum) ? warrantyPriceNum.toLocaleString() : product.price;
      // console.log(`Product ID: ${product.product_id}, Price: ${product.price}`);
      jQuery(".extended_warranty_attached_price").val(product.price);
      jQuery(".current_warranty_price").html(warrantyPriceFormatted);
      if (jQuery(".battery_price_add").hasClass("active")) {
        var warrantyPriceValue = document.querySelector(
          ".warranty__price span"
        ).innerHTML;
        jQuery(".battery_price_add").html(
          "+ " + warrantyPriceValue + " (Extended Warranty)"
        );
      }
      jQuery(".add_extended_warranty").val(product.product_id);
      if (product.cost !== undefined && product.cost !== null) {
        jQuery(".extended_warranty_cost").val(product.cost);
      }
      warrantyPrice = product.price;
    }
  });
  return warrantyPrice;
}

// hard reload page when back or forward from browser
window.addEventListener("popstate", function () {
  window.location.reload(true);
});

// hard reload page when back or forward from mobile
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    window.location.reload(true);
  }
});

function setWarrantyAttributes() {
  var SelectedVariantId = document.getElementById("SelectedVariantId").value;
  var product_variants = window.bcpo_product.variants;

  for (var i = 0; i < product_variants.length; i++) {
    var variant = product_variants[i];
    if (variant.id == SelectedVariantId) {
      document.getElementById("extWarrantyOf").value = variant.title;
      break;
    }
  }
}

setTimeout(function () {
  adjusttabbytamaraprices();
}, 1500);

function adjusttabbytamaraprices() {
  if (document.documentElement.lang === "ar") {
    var currency = global_Arabic_currency;
  } else {
    var currency = global_currency;
  }
  // Select the element containing the price
  let priceElement = document.querySelector(".price-item.price-item--sale");
  if (priceElement) {
    let priceText = priceElement.textContent.trim();

    // Remove the currency and any commas to get the numeric value
    let numericPrice = parseFloat(priceText.replace(/[^0-9.]/g, ""));

    // Divide the price by 4
    let dividedPrice = numericPrice / 4;

    //// Tabby / Tamara: divide the price by 6
    let dividedTabbyTamaraPrice = numericPrice / 6;

    //// divide the price by 3
    let dividedPrice2 = numericPrice / 3;

    //// divide the price by 24
    let dividedPrice3 = numericPrice / 24;

    //// divide the price by 24
    let dividedPrice4 = numericPrice / 2;

    // Round the result to 2 decimal places
    let roundedDividedPrice = dividedPrice.toFixed(2);
    let roundedDividedPrice2 = dividedPrice2.toFixed(2);
    let roundedDividedPrice3 = dividedPrice3.toFixed(2);
    let roundedDividedPrice4 = dividedPrice4.toFixed(2);

    let priceElements = document.querySelectorAll(".tabby_sec_price");
    priceElements.forEach(function (element) {
      element.innerHTML = dividedTabbyTamaraPrice.toFixed(2);
    });
    if (global_store == "ksa" || global_store == "ksa-virgin") {
      let dividedBaseetaPrice = numericPrice / 36;
      let roundedDividedBaseetaPrice = dividedBaseetaPrice.toFixed(2);
      let priceElementsBaseeta =
        document.querySelectorAll(".baseeta_sec_price");
      priceElementsBaseeta.forEach(function (element) {
        element.innerHTML = roundedDividedBaseetaPrice;
      });
    }

    let priceElements2 = document.querySelectorAll(".pay_just_now_price");
    priceElements2.forEach(function (element) {
      element.innerHTML = roundedDividedPrice2;
    });

    let priceElements3 = document.querySelectorAll(".float_price");
    priceElements3.forEach(function (element) {
      element.innerHTML = roundedDividedPrice;
    });

    let priceElements4 = document.querySelectorAll(".payflex_price");
    priceElements4.forEach(function (element) {
      element.innerHTML = roundedDividedPrice;
    });

    let priceElements5 = document.querySelectorAll(".happy_pay_price");
    priceElements5.forEach(function (element) {
      element.innerHTML = roundedDividedPrice4;
    });
  }
}

function openSupplierModal() {
  var body = document.querySelector("body");
  body.classList.add("seller-supplier-sidebar-show");
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000); // Convert days to milliseconds
  const expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; // Always set path to "/"
  // console.log(`Cookie set: ${cname}=${cvalue}; Expires: ${expires}`); // Debugging
}

let headerCountdownInterval;
const headerCountdownDuration = 15 * 60 * 1000; // 15 minutes in milliseconds

// Function to start header countdown
function startHeaderCountdown() {
  const popupStartTime = getCookie("popupStartTime");
  const showHeaderTimer = getCookie("showHeaderTimer");

  // Ensure the popup timer has started and the header timer flag exists
  if (!popupStartTime || !showHeaderTimer) {
    return; // If either cookie is missing, exit
  }

  const currentTime = new Date().getTime();
  const elapsedTime = currentTime - parseInt(popupStartTime);
  const remainingTime = headerCountdownDuration - elapsedTime;

  // If time has expired, reset cookies and timer display
  if (remainingTime <= 0) {
    clearInterval(headerCountdownInterval);
    deleteCookie("popupStartTime");
    updateHeaderTimer(0, 0, 0); // Show 00:00:00
    return;
  }

  // Start the header countdown
  runHeaderCountdown(remainingTime);
}

// Function to run the header countdown
function runHeaderCountdown(remainingTime) {
  clearInterval(headerCountdownInterval); // Clear any existing interval

  headerCountdownInterval = setInterval(function () {
    if (remainingTime <= 0) {
      clearInterval(headerCountdownInterval);
      deleteCookie("popupStartTime");
      updateHeaderTimer(0, 0, 0); // Show 00:00:00
      return;
    }

    remainingTime -= 1000; // Decrease time by 1 second

    // Calculate hours, minutes, and seconds
    const hours = Math.floor(
      (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor(
      (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

    // Update the header timer display
    updateHeaderTimer(hours, minutes, seconds);
  }, 1000);
}

// Function to update the header timer (class="free_del_top")
function updateHeaderTimer(hours, minutes, seconds) {
  // Select all elements with the class '.free_del_top'
  const headerTimerElements = document.querySelectorAll(".free_del_top");

  // Loop through each element and update the content
  headerTimerElements.forEach((headerTimerElement) => {
    let timerText;

    // Build the message based on the language
    if (document.documentElement.lang === "ar") {
      timerText =
        "استخدم كود الخصم NEXT15 و احصل على خصم 50 درهم اذا قمت بالطلب خلال ";
    } else {
      timerText = "if you order within the next ";
    }

    // Add the formatted time
    timerText += `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;

    // Append the closing part of the message based on the language
    if (document.documentElement.lang === "ar") {
      timerText += " دقيقة القادمة!";
    } else {
      timerText += " .Use discount code NEXT15 to claim this offer";
    }

    // Update the text content for each element
    headerTimerElement.textContent = timerText;
  });
}

startHeaderCountdown(); // Ensure to trigger the header countdown on load

function copyDiscountCode() {
  // Get the discount code text
  const discountCode = document.querySelector(
    ".discount-code-popup span"
  ).innerText;

  // Create a temporary input to copy the text
  const tempInput = document.createElement("input");
  document.body.appendChild(tempInput);
  tempInput.value = discountCode;
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);

  // Show confirmation message
  const confirmationMessage = document.getElementById("copy-confirmation");
  confirmationMessage.style.display = "block";

  // Hide the confirmation message after 2 seconds
  setTimeout(() => {
    confirmationMessage.style.display = "none";
  }, 3000);
}

function closeSupplierDrawer() {
  var body = document.querySelector("body");
  body.classList.remove("seller-supplier-sidebar-show");
}

document.addEventListener("click", function (event) {
  if (document.body.classList.contains("seller-supplier-sidebar-show")) {
    if (!event.target.closest(".halo-seller-supplier-sidebar")) {
      document.body.classList.remove("seller-supplier-sidebar-show");
    }
  }
});

function updateVariantSupplier(variant_id) {
  const supplierUid = supplier_variants[variant_id];
  var current_variant_supplier = suppliers_data.find(
    (supplier_data) => supplier_data.uid === supplierUid
  );
  if (current_variant_supplier) {
    jQuery(".revibe-supplier-topseller").show();

    jQuery(".revibe-supplier-name").html(current_variant_supplier.name);
    if (current_variant_supplier["top-seller"] == false) {
      jQuery(".revibe-supplier-topseller").hide();
    }
    //console.log("CurrentSupplier",current_variant_supplier);
    var supplier_score = parseFloat(current_variant_supplier?.score);
    if (isNaN(supplier_score)) supplier_score = 4.5;
    var spRound = Math.round(supplier_score * 2) / 2;
    // Update the 'data-rating' attribute with the value of spRound
    document.querySelectorAll(".sp_ratings").forEach(function(el) { el.setAttribute("data-rating", spRound); });
    jQuery(".revibe-supplier-score").html(supplier_score + "/5");
    var htmlScode = supplier_score + "/5";

    var labelTxt = "Authenticated & sold by";
    if (document.documentElement.lang === "ar") {
      var labelTxt = "	معتمد و مباع من قبل";
    }
    if (current_variant_supplier.name) {
      jQuery(".supplierDiv").html(
        '<div class="seller-info"> <span>' +
          labelTxt +
          ' </span>  </div>  <div class="seller-rating-stars">     <a href="javascript:openSupplierModal()" class="seller-name">' +
          current_variant_supplier.name +
          '</a><ul class="rating sp_ratings" data-rating="' +
          spRound +
          '"><li class="rating__item"></li><li class="rating__item"></li><li class="rating__item"></li> <li class="rating__item"></li> <li class="rating__item"></li>  </ul><span class="rating-value">' +
          htmlScode +
          "</span> </div>"
      );
    }
    //if(bcpo_product && bcpo_product.handle=='iphone-7')

    jQuery(".halo_right_variations_sect").css("display", "block");

    var joining_date = current_variant_supplier["joining-date"];

    jQuery(".seller_since").html(joining_date);

    var sales = current_variant_supplier["sales"];
    var formattedSales = Number(sales).toLocaleString();

    jQuery(".sales_supplier").html(formattedSales);

    var monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    //// Review 1/////
    var review_1_date = current_variant_supplier["date-review-1"];
    var dateObj = new Date(review_1_date);
    
    if (!isNaN(dateObj)) {
      var day = dateObj.getDate().toString().padStart(2, "0");
      var month = dateObj.getMonth(); // 0-based
      var year = dateObj.getFullYear();
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var formattedDate_1 = `${day}/${String(month + 1).padStart(2, "0")}/${String(year).slice(-2)}`;
        jQuery(".review_1_date").html(formattedDate_1);
    } else {
      console.warn("Invalid date format:", review_1_date);
    }
    
    jQuery(".review-1-customer-name").html(
      current_variant_supplier["name-review-1"]
    );
    jQuery(".review-1-phone-title").html(
      current_variant_supplier["model-review-1"]
    );
    jQuery(".review-1-model").html(
      current_variant_supplier["variation-review-1"]
    );
    jQuery(".title-review-1").html(current_variant_supplier["title-review-1"]);

    //// Review 2/////
    var review_1_date = current_variant_supplier["date-review-2"];
    var dateObj = new Date(review_1_date);
    
    if (!isNaN(dateObj)) {
      var day = dateObj.getDate().toString().padStart(2, "0");
      var month = dateObj.getMonth(); // 0-based
      var year = dateObj.getFullYear();
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var formattedDate_1 = `${day}/${String(month + 1).padStart(2, "0")}/${String(year).slice(-2)}`;
        jQuery(".review_2_date").html(formattedDate_1);
    } else {
      console.warn("Invalid date format:", review_1_date);
    }
    jQuery(".review-2-customer-name").html(
      current_variant_supplier["name-review-2"]
    );
    jQuery(".review-2-phone-title").html(
      current_variant_supplier["model-review-2"]
    );
    jQuery(".review-2-model").html(
      current_variant_supplier["variation-review-2"]
    );
    jQuery(".title-review-2").html(current_variant_supplier["title-review-2"]);

    //// Review 3/////
    var review_1_date = current_variant_supplier["date-review-3"];
    var dateObj = new Date(review_1_date);
    
    if (!isNaN(dateObj)) {
      var day = dateObj.getDate().toString().padStart(2, "0");
      var month = dateObj.getMonth(); // 0-based
      var year = dateObj.getFullYear();
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var formattedDate_1 = `${day}/${String(month + 1).padStart(2, "0")}/${String(year).slice(-2)}`;
        jQuery(".review_3_date").html(formattedDate_1);
    } else {
      console.warn("Invalid date format:", review_1_date);
    }
    jQuery(".review-3-customer-name").html(
      current_variant_supplier["name-review-3"]
    );
    jQuery(".review-3-phone-title").html(
      current_variant_supplier["model-review-3"]
    );
    jQuery(".review-3-model").html(
      current_variant_supplier["variation-review-3"]
    );
    jQuery(".title-review-3").html(current_variant_supplier["title-review-3"]);

    //// Review 4/////
    var review_1_date = current_variant_supplier["date-review-4"];
    var dateObj = new Date(review_1_date);
    
    if (!isNaN(dateObj)) {
      var day = dateObj.getDate().toString().padStart(2, "0");
      var month = dateObj.getMonth(); // 0-based
      var year = dateObj.getFullYear();
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      var formattedDate_1 = `${day}/${String(month + 1).padStart(2, "0")}/${String(year).slice(-2)}`;
        jQuery(".review_4_date").html(formattedDate_1);
    } else {
      console.warn("Invalid date format:", review_1_date);
    }
    
    jQuery(".review-4-customer-name").html(
      current_variant_supplier["name-review-4"]
    );
    jQuery(".review-4-phone-title").html(
      current_variant_supplier["model-review-4"]
    );
    jQuery(".review-4-model").html(
      current_variant_supplier["variation-review-4"]
    );
    jQuery(".title-review-4").html(current_variant_supplier["title-review-4"]);

    ///////////// remaining Reviews//////////
    var score_review_1 = parseFloat(current_variant_supplier["score-review-1"]);
    var score_review_2 = parseFloat(current_variant_supplier["score-review-2"]);
    var score_review_3 = parseFloat(current_variant_supplier["score-review-3"]);
    var score_review_4 = parseFloat(current_variant_supplier["score-review-4"]);
    if (isNaN(score_review_1)) score_review_1 = 4.5;
    if (isNaN(score_review_2)) score_review_2 = 4.5;
    if (isNaN(score_review_3)) score_review_3 = 4.5;
    if (isNaN(score_review_4)) score_review_4 = 4.5;

    score_review_1 = Math.round(score_review_1 * 2) / 2;
    score_review_2 = Math.round(score_review_2 * 2) / 2;
    score_review_3 = Math.round(score_review_3 * 2) / 2;
    score_review_4 = Math.round(score_review_4 * 2) / 2;

    var ratingElement = document.querySelector(".review1Rating");
    if (ratingElement) ratingElement.setAttribute("data-rating", score_review_1);

    var ratingElement = document.querySelector(".review2Rating");
    if (ratingElement) ratingElement.setAttribute("data-rating", score_review_2);

    var ratingElement = document.querySelector(".review3Rating");
    if (ratingElement) ratingElement.setAttribute("data-rating", score_review_3);

    var ratingElement = document.querySelector(".review4Rating");
    if (ratingElement) ratingElement.setAttribute("data-rating", score_review_4);

    var review_1 = current_variant_supplier["review-1"];
    var review_2 = current_variant_supplier["review-2"];
    var review_3 = current_variant_supplier["review-3"];
    var review_4 = current_variant_supplier["review-4"];

    jQuery(".revibe-supplier-review-1").html(review_1);
    jQuery(".revibe-supplier-review-2").html(review_2);
    jQuery(".revibe-supplier-review-3").html(review_3);
    jQuery(".revibe-supplier-review-4").html(review_4);
  }
}
function checkLeastPrice() {
  var current_variant_id = document.querySelector('input[name="id"]').value;
  var variants = bcpo_product.variants;
  // Filter variants that meet the conditions: inventory_quantity > 0 and price > 0
  var eligibleVariants = variants.filter(
    (variant) => variant.inventory_quantity > 0 && variant.price > 0
  );

  // Find the variant with the least price
  var leastPriceVariant = eligibleVariants.reduce(
    (minVariant, currentVariant) => {
      return currentVariant.price < minVariant.price
        ? currentVariant
        : minVariant;
    },
    eligibleVariants[0]
  ); // Initialize with the first eligible variant

  // Output the least price variant and its price
  //console.log("Least Price Variant:", leastPriceVariant);
  //console.log("Least Price:", leastPriceVariant.price/100);
  var leastProductPrice = leastPriceVariant.price / 100;
  var leastVariantId = leastPriceVariant.id;
  var option1 = leastPriceVariant.option1;
  var option2 = leastPriceVariant.option2;
  var option3 = leastPriceVariant.option3;

  var combinedInput = option1 + " | " + option2 + " | " + option3;
  var leastProductElement = document.getElementById("product_details_least");
  if (leastProductElement) {
    leastProductElement.innerHTML = combinedInput;
  }

  var lowestCta = document.getElementById("lowestCta"); // If selecting by ID

  if (lowestCta) {
    if (leastVariantId == current_variant_id) {
      //lowestCta.classList.add("available");
      document.getElementById("lowest_price_variant_id").value = leastVariantId;
    } else {
      //lowestCta.classList.remove("available");
    }
  }

  // Update the least product price in the DOM
  var leasetProductPrice = document.getElementById("leastProductPrice");
  if (leasetProductPrice) {
    leasetProductPrice.innerHTML = "AED " + leastProductPrice;
  }

  highlightMatchingOptions(option1, option2, option3);
}

function highlightMatchingOptions(option1, option2, option3) {
  // Get all radio inputs for the product form
  var radioButtons = document.querySelectorAll(".product-form__radio");

  // Loop through each radio button to check for matching option values
  radioButtons.forEach(function (radio) {
    // Get the radio button's value
    var radioValue = radio.value; // e.g., "128 GB"

    // Find the corresponding label using the 'for' attribute
    var label = document.querySelector('label[for="' + radio.id + '"]');

    if (label) {
      // Check if the radio button's value matches any of the options
      if (
        radioValue === option1 ||
        radioValue === option2 ||
        radioValue === option3
      ) {
        // If a match is found, add the 'leastProductVar' class to the label
        label.classList.add("leastProductVar");
      } else {
        // Optionally, remove the class if not matching (for reactivity)
        label.classList.remove("leastProductVar");
      }
    }
  });
}

function activeLowestVariant() {
  document.querySelectorAll(".leastProductVar").forEach(function (element) {
    element.click();
  });
}

function closeMyTradeIDBar() {
  const notificationBar = document.querySelector(".notificationBar");
  notificationBar.classList.add("hidden");
  setCookie("hideNotificationBar", "true", 3);
}

document.addEventListener("click", function (event) {
  const link = event.target.closest('a[href="#golo-form-seller"]');

  if (link) {
    event.preventDefault(); // Prevent the default anchor behavior

    // Select the target element to scroll to
    const targetElement = document.querySelector("#golo-form-seller");
    if (targetElement) {
      // Smoothly scroll to the target element
      targetElement.scrollIntoView({
        behavior: "smooth",
      });
    }
  }
});

function openRenewedModal() {
  var body = document.querySelector("body");
  body.classList.add("renewed-sidebar-show");
}

function closeRenewedModal() {
  var body = document.querySelector("body");
  body.classList.remove("renewed-sidebar-show");
}

document.addEventListener("click", function (event) {
  if (document.body.classList.contains("renewed-sidebar-show")) {
    if (!event.target.closest(".halo-renewed-revibe-sidebar")) {
      document.body.classList.remove("renewed-sidebar-show");
    }
  }
});

function openCashBackModal() {
  var body = document.querySelector("body");
  body.classList.add("cashback-sidebar-show");
}

function closeCashBackModal() {
  var body = document.querySelector("body");
  body.classList.remove("cashback-sidebar-show");
}

document.addEventListener("click", function (event) {
  if (document.body.classList.contains("cashback-sidebar-show")) {
    if (!event.target.closest(".halo-cashback-revibe-sidebar")) {
      document.body.classList.remove("cashback-sidebar-show");
    }
  }
});

function openEsimGuideModal() {
  var body = document.querySelector("body");
  body.classList.add("esim-guide-sidebar-show");
}

function closeEsimGuideModal() {
  var body = document.querySelector("body");
  body.classList.remove("esim-guide-sidebar-show");
}

document.addEventListener("click", function (event) {
  if (document.body.classList.contains("esim-guide-sidebar-show")) {
    if (!event.target.closest(".halo-esim-revibe-sidebar")) {
      document.body.classList.remove("esim-guide-sidebar-show");
    }
  }
});

function blackFridayCounter() {
  // Set the target date to November 29, 2024
  const targetDate = new Date("2026-03-23T23:59:59");

  // Function to calculate remaining time and update all counters
  function updateCounter() {
    const now = new Date();
    const remainingTime = targetDate - now;

    if (remainingTime <= 0) {
      // Stop updating if the target date is reached
      clearInterval(interval);
      document
        .querySelectorAll(".days_black_friday")
        .forEach((el) => (el.textContent = "00"));
      document
        .querySelectorAll(".hours_black_friday")
        .forEach((el) => (el.textContent = "00"));
      document
        .querySelectorAll(".sec_black_friday")
        .forEach((el) => (el.textContent = "00"));
      return;
    }

    // Calculate days, hours, and seconds
    const totalSeconds = Math.floor(remainingTime / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const days = Math.floor(totalHours / 24); // Total days remaining
    const hours = totalHours % 24; // Hours remaining after the last full day
    const minutes = totalMinutes % 60;
    const seconds = totalSeconds % 60; // Seconds remaining after the last full minute

    // Update all divs with the corresponding class
    document
      .querySelectorAll(".days_black_friday")
      .forEach((el) => (el.textContent = String(days).padStart(2, "0")));
    document
      .querySelectorAll(".hours_black_friday")
      .forEach((el) => (el.textContent = String(hours).padStart(2, "0")));
    document
      .querySelectorAll(".min_black_friday")
      .forEach((el) => (el.textContent = String(minutes).padStart(2, "0")));
    document
      .querySelectorAll(".sec_black_friday")
      .forEach((el) => (el.textContent = String(seconds).padStart(2, "0")));
  }

  // Initial update
  updateCounter();

  // Update every second
  const interval = setInterval(updateCounter, 1000);
}

// Call the function to start the counter
//blackFridayCounter();

function fbrVariantTagSticky() {
  var current_variant_id = document.getElementById("SelectedVariantId").value;
  var variants = window.fbr_variants;
  if (variants[current_variant_id] === "true") {
    var elements = document.querySelectorAll(".sticky-product-wrapper");
    elements.forEach((element) => {
      // Check if the class is already present
      if (!element.classList.contains("enable-revibe-express-thunder-icon")) {
        element.classList.add("enable-revibe-express-thunder-icon");
      }
    });
    // var selectedVariantValue = document.querySelector(
    //   "body.template-product .productView-stickyCart.style-1 .sticky-options .select__select.custom-product-title-dropdown"
    // ).selectedOptions[0].textContent;
    // document.querySelector(".revibe-express-product-meta").textContent =
    //   selectedVariantValue;

    var selectedVariantDropdown = document.querySelector(
      "body.template-product .productView-stickyCart.style-1 .sticky-options .select__select.custom-product-title-dropdown"
    );
    
    if (selectedVariantDropdown && selectedVariantDropdown.selectedOptions.length > 0) {
      var selectedVariantValue = selectedVariantDropdown.selectedOptions[0].textContent;
    
      var metaElement = document.querySelector(".revibe-express-product-meta");
      if (metaElement) {
        metaElement.textContent = selectedVariantValue;
      }
    }
    
  } else {
    var elements = document.querySelectorAll(".sticky-product-wrapper");

    elements.forEach((element) => {
      // Check if the class is present
      if (element.classList.contains("enable-revibe-express-thunder-icon")) {
        element.classList.remove("enable-revibe-express-thunder-icon");
      }
    });
  }
}

function checkBlackFridayVariants() {
  setTimeout(() => {
    var current_variant_id = document.getElementById("SelectedVariantId").value;
    var variants = window.black_friday_variants;
    var modifyCashBackOrWhiteFridayClass = document.querySelector(
      ".sticky-product-wrapper"
    );
    var numericPrice = 0;
    var bcpoVariant = (window.bcpo_product_main?.variants || []).find(
      function(v) { return String(v.id) === String(current_variant_id); }
    );
    if (bcpoVariant) {
      numericPrice = parseFloat(String(bcpoVariant.price || "").replace(/[^\d.]/g, "")) || 0;
    } else {
      var priceEl = document.querySelector(
        ".halo-productView-right .productView-price .price__sale .price__last .price-item"
      );
      if (priceEl) numericPrice = Number(priceEl.textContent.replace(/[^\d]/g, ""));
    }

    //updateStickyPrice(numericPrice);

    if (variants[current_variant_id] === "true") {
      if (
        !modifyCashBackOrWhiteFridayClass.classList.contains(
          "enable-white-friday-sticky-pdp"
        )
      ) {
        modifyCashBackOrWhiteFridayClass.classList.add(
          "enable-white-friday-sticky-pdp"
        );
      }
    } else {
      if (
        modifyCashBackOrWhiteFridayClass.classList.contains(
          "enable-white-friday-sticky-pdp"
        )
      ) {
        modifyCashBackOrWhiteFridayClass.classList.remove(
          "enable-white-friday-sticky-pdp"
        );
      }
    }

    // if (
    //   (global_store === "uae" && numericPrice >= 1000) ||
    //   (global_store === "ksa" && numericPrice >= 1000) ||
    //   (global_store === "ksa-virgin" && numericPrice >= 1000) ||
    //   (global_store === "za" && numericPrice >= 5000)
    // ) {
    //   if (
    //     !modifyCashBackOrWhiteFridayClass.classList.contains(
    //       "enable-cash-back-deal-sticky-pdp"
    //     )
    //   ) {
    //     modifyCashBackOrWhiteFridayClass.classList.add(
    //       "enable-cash-back-deal-sticky-pdp"
    //     );
    //   }
    // } else {
    //   if (
    //     modifyCashBackOrWhiteFridayClass.classList.contains(
    //       "enable-cash-back-deal-sticky-pdp"
    //     )
    //   ) {
    //     modifyCashBackOrWhiteFridayClass.classList.remove(
    //       "enable-cash-back-deal-sticky-pdp"
    //     );
    //   }
    // }

    const shouldEnableCashBack =
    (global_store === "uae" && numericPrice >= 1000) ||
    (global_store === "ksa" && numericPrice >= 1000) ||
    (global_store === "ksa-virgin" && numericPrice >= 1000) ||
    (global_store === "za" && numericPrice >= 5000);

    const cashBackToolTips = document.querySelectorAll(".additional-cash-back-anchor-tooltip");
    if (cashBackToolTips) {
      cashBackToolTips.forEach(el => {
        el.classList.toggle("enable-cbd-tooltip", shouldEnableCashBack);
      });
    }

  }, 650); // Delay execution by 200ms (adjust as needed)
}

function set_bestDeal() {
  const labels = document.querySelectorAll(
    ".product_form_condition_swatch label"
  );
  let conditions = [];

  labels.forEach((label) => {
    const mainSpan = label.querySelector("span");
    if (mainSpan) {
      const clonedMainSpan = mainSpan.cloneNode(true);
      const priceSpan = clonedMainSpan.querySelector(".variant-price-in-box");
      if (priceSpan) priceSpan.remove();

      const conditionText = clonedMainSpan.textContent.trim();
      let priceValue = null;
      if (priceSpan) {
        let priceText = priceSpan.textContent.trim().replace(/[^0-9.-]+/g, "");
        priceValue = parseInt(priceText, 10);
      }

      if (priceValue !== null) {
        conditions.push({ condition: conditionText, price: priceValue, label });
      }
    }
  });
  var conditionTxt = "new";
  if (document.documentElement.lang === "ar") {
    conditionTxt = "جديد";
  }
  const newCondition = conditions.find(
    (c) => c.condition.toLowerCase().trim() == conditionTxt && c.price > 0
  );
  if (newCondition) {
    const bestDeal = conditions
      .filter((c) => c.condition.toLowerCase().trim() != conditionTxt)
      .reduce(
        (best, current) => (current.price < best.price ? current : best),
        { price: Infinity }
      );

    if (newCondition.price < bestDeal.price) {
      var bestDealClass = "best-deal";
      var bestDealHTML =
        '<span class="great-deal-wrapper"><span class="great-deal-tag">Deal</span></span>';
      if (document.documentElement.lang === "ar") {
        newCondition.label.classList.add("best-deal-ar");
        bestDealHTML =
          '<span class="great-deal-wrapper"><span class="great-deal-tag">لا يفوتك!</span></span>';
      }
      newCondition.label.classList.add(bestDealClass);
      newCondition.label.insertAdjacentHTML("beforeend", bestDealHTML);
    }
  }
}

function languageSwitcher(targetLocale) {
  const supported = ["ar", "th", "ms", "zh", "zh-TW", "id", "fil", "th-th", "en-th"];
  const rootUrl = window.location.origin;
  const path = window.location.pathname;
  const query = window.location.search;

  // remove any existing locale prefix
  const localeRegex = new RegExp(`^\\/(${supported.join("|")})(\\/|$)`, "i");
  const basePath = path.replace(localeRegex, "/");
  const cleanBasePath = basePath === "/" ? "" : basePath;

  // If target is English => no prefix
  if (!targetLocale || targetLocale === "en") {
    window.location.href = rootUrl + cleanBasePath + query;
    return;
  }

  if (!supported.includes(targetLocale)) {
    console.warn("Unsupported locale:", targetLocale);
    return;
  }

  let finalLocale = targetLocale.toLowerCase();
  if (finalLocale === "zh-tw") finalLocale = "zh";

  window.location.href = rootUrl + `/${finalLocale}` + cleanBasePath + query;
}


document.addEventListener("DOMContentLoaded", updateLabelVisibility);
document.querySelectorAll(".product-form__radio").forEach((radio) => {
  radio.addEventListener("change", updateLabelVisibility);
});

function updateLabelVisibility() {
  setTimeout(function () {
  var currentUrl = window.location.href;
  if (!currentUrl.includes("products/")) return;
  
  const productVariants = window.bcpo_product.variants;
  const fieldsets = document.querySelectorAll(".product-details .product-option fieldset.product-form__input");

  if (fieldsets.length < 1) return; // At least one fieldset should exist

  let selectedColor = "";
  let colorFieldset = null;

  // **Step 1: Handle First Fieldset (Color) If Exists**
  if (fieldsets.length > 0 && fieldsets[0].classList.contains("product_form_color_swatch")) {
    colorFieldset = fieldsets[0];
    selectedColor = processFieldset(colorFieldset, []); // No dependencies for color
  }

  // Hide Color Fieldset if no variants exist for any color
  if (colorFieldset && !hasAnyAvailableOption(colorFieldset, [])) {
    colorFieldset.style.display = "none";
    selectedColor = ""; // No color available, reset value
  } else if (colorFieldset) {
    colorFieldset.style.display = "block"; // Show if available
  }

  let selectedOption2 = fieldsets.length > 1 ? getCheckedValue(getFieldsetSelector(fieldsets[1])) : "";
  let selectedOption3 = fieldsets.length > 2 ? getCheckedValue(getFieldsetSelector(fieldsets[2])) : "";

  // **Step 2: Process Second Fieldset (Storage / Other Option)**
  if (fieldsets.length > 1) {
    selectedOption2 = processFieldset(fieldsets[1], [selectedColor]);
  }

  // **Step 3: Process Third Fieldset (Condition / Other Option)**
  if (fieldsets.length > 2) {
    selectedOption3 = processFieldset(fieldsets[2], [selectedColor, selectedOption2]);
  }
  }, 2000);
}

/** Process Fieldset: Hide Unavailable Options and Auto-Select if Needed */
function processFieldset(fieldset, conditions) {
  const fieldsetClass = getFieldsetSelector(fieldset);
  const inputs = fieldset.querySelectorAll(".product-form__radio");

  let selectedValue = getCheckedValue(fieldsetClass);
  let isVariantFound = false;
  let availableValues = [];

  const certifiedModalAnchor = document.querySelector(".apple-certified-modal-anchor");
  let shouldShowCertifiedAnchor = false;
  let cartText = global_add_to_cart;
  let SoldText = global_sold_out;
  // if (document.documentElement.lang === "ar") {
  //   cartText = "أضف إلى السلة";
  //   SoldText = "نفذ";
  // }
  const stickyAddToCartButtons = document.querySelectorAll("button#product-sticky-add-to-cart");
    var current_product_price = parseFloat(
          $(".productView-price .price-item--sale")
            .html()
            .replace(new RegExp(global_currency + "\\s*|,", "g"), "")
        );
  // console.log(current_product_price);
    if(current_product_price!=0){
      stickyAddToCartButtons.forEach(button => {
        //button.textContent = cartText;
        if (button.hasAttribute("disabled")) {
         // button.removeAttribute("disabled");
        }
      });
    } else {
      stickyAddToCartButtons.forEach(button => {
       // button.textContent = SoldText;
        //  button.setAttribute("disabled", "disabled");
      });
    }
  inputs.forEach((input) => {
    const optionValue = input.value;
    let currentOptions = [...conditions, optionValue];
    const label = input.nextElementSibling;

    if (!label) return;
    if (isVariantAvailable(...currentOptions)) {
      isVariantFound = isVariantFound || selectedValue === optionValue;
      availableValues.push(optionValue);
      //label.style.display = "inline-block"; // Show available options
      label.classList.remove('soldout-custom');
      if (label.classList.contains("apple-renewed-label")) {
        shouldShowCertifiedAnchor = true;
      }
    } else {
      //label.style.display = "none"; // Hide unavailable options
      //label.classList.add('soldout-custom');
    }
  });

  if (certifiedModalAnchor) {
    certifiedModalAnchor.style.display = shouldShowCertifiedAnchor ? "block" : "none";
  }

  // Hide fieldset if no options are available
  //fieldset.style.display = availableValues.length > 0 ? "flex" : "none";

  if (!isVariantFound && availableValues.length > 0) {
    // selectOption(inputs, availableValues[0], fieldsetClass); // Auto-select the first available value
    // return availableValues[0]; // Return the newly selected value
    return "";
  }

  return selectedValue; // Return the same selected value if it's available
}

/** Helper: Check if a Variant Exists */
function isVariantAvailable(...options) {
  return window.bcpo_product.variants.some(
    (variant) =>
      options.every((opt, index) => (!opt || variant[`option${index + 1}`] === opt)) &&
      variant.inventory_quantity > 0 &&
      variant.price > 0
  );
}

/** Helper: Check if Any Option in a Fieldset is Available */
function hasAnyAvailableOption(fieldset, conditions) {
  const inputs = fieldset.querySelectorAll(".product-form__radio");
  return [...inputs].some((input) => isVariantAvailable(...conditions, input.value));
}

/** Helper: Get Checked Value */
function getCheckedValue(selector) {
  return document.querySelector(`${selector} .product-form__radio:checked`)?.value || "";
}

/** Helper: Get Fieldset Selector */
function getFieldsetSelector(fieldset) {
  return `.${fieldset.classList[1]}`;
}

/** Helper: Select an Option */
function selectOption(inputs, value, fieldsetClass) {
  const input = [...inputs].find((input) => input.value === value);
  if (input) input.click();
}

document.addEventListener("DOMContentLoaded", function () {
  // Select all elements with the class 'p-discount'
  const discountElements = document.querySelectorAll(".p-discount");
  if (discountElements) {
    discountElements.forEach((element, index) => {
      // Get the discount from the data attribute
      let pDiscount = parseInt(element.getAttribute("data-discount"));

      // Randomize if discount is 0 or 100
      if (pDiscount === 0 || pDiscount === 100) {
        // Create a random value between 10 and 70
        pDiscount = Math.floor(Math.random() * 61) + 10 + index; // Ensure some variation using index
      }

      // Update the displayed discount value
      element.textContent = pDiscount + "%";
    });
  }
});



document.addEventListener("DOMContentLoaded", customCheckoutChanges);
window.addEventListener("pageshow", customCheckoutChanges);

function customCheckoutChanges() {

  const checkoutBTNS = document.querySelectorAll(".button-checkout");
  checkoutBTNS.forEach(handleCheckoutBtn);
}

function handleCheckoutBtn(checkoutButton) {
  const newCheckoutButton = checkoutButton.cloneNode(true);
  checkoutButton.onclick = null;
  checkoutButton.parentNode.replaceChild(newCheckoutButton, checkoutButton);
  newCheckoutButton.addEventListener("click", checkoutBtnEventHandler);
}

async function getCartDetails() {
  return fetch("/cart.js").then((resp) => resp.json());
}

async function isMatchProduct(cart) {
  let checkFlag = true;
  const productPromises = cart.items.map((item) =>
    fetch(`/products/${item.handle}.js`)
      .then((response) => response.json())
      .then(
        (product) =>
          !product.tags.includes("custom-checkout") && (checkFlag = false)
      )
  );
  await Promise.all(productPromises);
  return checkFlag;
}

async function checkoutBtnEventHandler(event) {
  event.preventDefault();
  event.target.setAttribute("disabled", true);
  const CUSTOM_CHECKOUT_BASE_URL = "https://checkout.revibe.me/api";

  try {
    const cart = await getCartDetails();
    let collectionMatches = await isMatchProduct(cart);
    // some condition

    if (!collectionMatches) {
      window.location.href = "/checkout";
      return;
    }

    const payload = {
      cart,
      language: document.querySelector("html").getAttribute("lang"),
      customer: null,
      clientId: null,
      shopifySessionId: null,
    };
    const shop_name = Shopify.shop;
    const resp = await fetch(
      `${CUSTOM_CHECKOUT_BASE_URL}/cart/${shop_name}/create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await resp.json();
  //console.log(result);
    window.location.href = result.return_url;
    // console.log(result)
  } catch (error) {
    console.error("Failed to fetch cart details:", error);
  } finally {
    event.target.removeAttribute("disabled");
  }
}

function markloadingActive(t) {
  t.classList.add("is-loading");
}

function filterAndUpdateProductLinks() {
  const seenModels = new Set();

  document.querySelectorAll('[data-model-name]').forEach(el => {
    const modelName = el.getAttribute('data-model-name')?.trim();
    if (!modelName) return;

    // Hide duplicates
    if (seenModels.has(modelName)) {
      el.style.display = 'none';
    } else {
      seenModels.add(modelName);
    }

    // Update all product <a> links inside this element
    const links = el.querySelectorAll('a[href^="/products/"]');
    links.forEach(link => {
      const url = new URL(link.href, location.origin);
      const originalPath = url.pathname;

      const match = originalPath.match(/^\/products\/([^\/?]+)/);
      if (match) {
        const query = url.search;
        const newHref = `/products/${modelName}${query}`;
        link.setAttribute('href', newHref);
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  filterAndUpdateProductLinks();
  observePaginationChanges();
});

function observePaginationChanges() {
  const targetNode = document.querySelector('.productListing.productGrid');
  if (!targetNode) return;

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        filterAndUpdateProductLinks();
        break;
      }
    }
  });

  observer.observe(targetNode, { childList: true, subtree: true });
}

if (window.location.href.includes("products/")) {
  setTimeout(function () {
    const selectedVariantIDElement = document.querySelector('[name="id"]');
    
    if (!selectedVariantIDElement) return;
    var variantLength = window.bcpo_product.variants.length;

    const selectedVariantID = selectedVariantIDElement.value;
    let fbrVariantsArray = Array.isArray(window.fbrVariants) ? window.fbrVariants : [];
    const isFbrVariant = fbrVariantsArray.some(variant => variant.id == selectedVariantID);
    //console.log("is fbr variant", isFbrVariant);
    if (isFbrVariant && variantLength == 1) {
    //  console.log("is fbr variant exist");
      document.querySelectorAll(".sticky-info .sticky-options").forEach(el => {
        el.classList.add("enable-revibe-icon");
      });
    } else {
      document.querySelectorAll(".sticky-info .sticky-options").forEach(el => {
        el.classList.remove("enable-revibe-icon");
    });
  }
    for (const variant of bcpo_product.variants) {
      if (selectedVariantID == variant.id) {
        if (!variant.available) {
          const submitButtons = document.querySelectorAll('.product-form__submit');
          submitButtons.forEach(button => {
            let cartButtonText = global_sold_out;
            button.textContent = cartButtonText;
            button.disabled = true;
          });

      
        }
      }
    }
  }, 3000); // 2 seconds delay
}

function updateKeyBoardValue(vvl, labelElem) {
  jQuery(".keyboard_span").html(vvl);
  
       handleFunction(labelElem);

  
}



function handleVariantAvailability() {
  if(document.getElementById("templateName").value == "product-ipad-template"){
    return;
  }
  var currentUrl = window.location.href;
  if (!currentUrl.includes("products/")) return;

    var current_product_price = parseFloat(  $(".productView-price .price-item--sale").html().replace(new RegExp(global_currency + "\\s*|,", "g"), ""));
  setTimeout(function () {
    let selectedVariantIDElement = document.querySelector('[name="id"]');
    if (!selectedVariantIDElement) return;

    let selectedVariantID = selectedVariantIDElement.value;
    let stickyAddToCartButtons = document.querySelectorAll(".product-form__submit");

    let cartText = global_add_to_cart;
    let soldText = global_sold_out;

    // if (document.documentElement.lang === "ar") {
    //   cartText = "أضف إلى السلة";
    //   soldText = "نفذ";
    // }

    for (let variant of bcpo_product.variants) {
      if (selectedVariantID == variant.id) {
        if (window.blockAddToCartTH || !variant.available || current_product_price == 0) {

          stickyAddToCartButtons.forEach(button => {
            button.textContent = soldText;
            button.setAttribute("disabled", "true");
          });
        } else {
          stickyAddToCartButtons.forEach(button => {
            button.textContent = cartText;
            button.removeAttribute("disabled");
          });
        }
      }
    }
  }, 700); // 3 seconds delay
}

  
  document.querySelectorAll('.product-form__label').forEach(label => {
  label.addEventListener('click', handleVariantAvailability);
  });


handleVariantAvailability();










///////////////// Express Functions///////////////////
function isVisible(el) {
  return el && el.offsetParent !== null;
}

// Helper: trims + lower‑cases for safe comparisons
function normalize(str) {
  return (str || "").toString().trim().toLowerCase();
}

function CallExpressFunction() {
//console.log("Express Function is Called");

setTimeout(() => {
const variants = window.fbrVariants || [];
resetClassesExpress(); // remove old icons

/* Step 1 – what is currently selected? */
const selectedOptions = Array.from(
document.querySelectorAll("legend.form__label")
)

.map((legend) => {
const span = legend.querySelector("span");
return span ? normalize(span.textContent) : "";
});
//console.log("Selected Options Are",selectedOptions);
const selectedFirst = selectedOptions[0] || "";
const selectedSecond = selectedOptions[1] || "";
const selectedThird = selectedOptions[2] || "";

/* Step 2 – get every visible label */
const labels = Array.from(
document.querySelectorAll(".product-form__label")
).filter(isVisible);

/* Step 3 – add icon wherever rules match */
labels.forEach((label) => {
if (!label.htmlFor) return;
const input = document.getElementById(label.htmlFor);
if (!input) return;

const value = normalize(input.value);
let addIcon = false;

for (const v of variants) {
const v1 = normalize(v.option1);
const v2 = normalize(v.option2);
const v3 = normalize(v.option3);

if (value === v1) {
addIcon = true;
break;
}

if (
selectedFirst &&
v1 === selectedFirst &&
value === v2
) {

addIcon = true;
break;
}

if (
selectedFirst && selectedSecond &&
v1 === selectedFirst &&
v2 === selectedSecond &&
value === v3
) {
addIcon = true;
break;
}
}

if (addIcon) {
label.classList.add("fast-charging-icon");
}
});
}, 300); // 200ms delay
}
























  

function resetClassesExpress() {
 const labels = Array.from(
    document.querySelectorAll(".product-form__label")
  ).filter(isVisible);
  
  labels.forEach((label) => {
    let classList = label.classList;

  
    if (classList.contains("fast-charging-icon")) {
      classList.remove("fast-charging-icon");
    }
       if (classList.contains("customSoldout ")) {
      classList.remove("fast-charging-icon");
    }
  });


}

  function toStringSafe(value) {
    return value == null ? '' : String(value);
  }

  // Helper: Check if a flag is true-ish (1, "1", "true", true)
  function isTruthy(value) {
    return value === true || value === 'true' || value === '1' || value === 1;
  }

  // TH store may not add Smartphone type products to cart — catches
  // carts that already held one before this block existed, or a mini-cart/
  // other-page add that bypassed the PDP-level guards.
  function isBlockedThSmartphone(item) {
    if (typeof global_store === 'undefined' || global_store !== 'th') return false;
    var type = toStringSafe(item.product_type).toLowerCase();
    return type.indexOf('smartphone') !== -1;
  }

  async function cleanupOrphansOnce() {
    // Cheap synchronous guard: the header only renders `.cart-count-bubble`
    // when `cart != empty` (see sections/cart-icon-bubble.liquid). Checking
    // that avoids a `/cart.js` network round-trip on every page load for the
    // common case of an empty cart (most first-time/browsing visits).
    if (!document.querySelector('.cart-count-bubble')) return;

    try {
      // 1) Get cart JSON
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) return; // 503 etc. returns an HTML page, not JSON
      const cart = await response.json();
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

      // 2) Determine which line-item keys need removal
      const keysToRemove = new Set();
      const blockedVariantIds = new Set();

      cart.items.forEach((item) => {
        if (isBlockedThSmartphone(item)) {
          keysToRemove.add(item.key);
          blockedVariantIds.add(toStringSafe(item.id != null ? item.id : item.variant_id));
        }
      });

      // 3) Collect variant IDs that will still be in the cart after blocked
      // items are removed, so their bound warranty/cross-sell children are
      // treated as orphaned in this same pass instead of a later page load.
      const existingVariantIds = new Set(
        cart.items
          .map((item) => toStringSafe(item.id != null ? item.id : item.variant_id))
          .filter((id) => !blockedVariantIds.has(id))
      );

      cart.items.forEach((item) => {
        const props = item.properties || {};

        // If it's a warranty, remove if its linked variant is missing
        if (isTruthy(props._is_warranty)) {
          const linkedVariantId = toStringSafe(props._variantId);
          if (linkedVariantId && !existingVariantIds.has(linkedVariantId)) {
            keysToRemove.add(item.key);
          }
        }

        // If it's a child, remove if its parent variant is missing
        if (isTruthy(props._is_child)) {
          const parentVariantId = toStringSafe(props._parent_variant_id);
          if (parentVariantId && !existingVariantIds.has(parentVariantId)) {
            keysToRemove.add(item.key);
          }
        }
      });

      if (keysToRemove.size === 0) return;

      // 4) Attempt single-batch removal via /cart/update.js
      const updatePayload = {};
      keysToRemove.forEach((key) => (updatePayload[key] = 0));

      let batchWorked = false;
      try {
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updatePayload }),
        });

        if (updateResponse.ok) batchWorked = true;
      } catch (err) {
        console.warn('Batch removal failed, falling back to individual:', err);
      }

      // 5) Fallback: sequential removal (if batch failed)
      if (!batchWorked) {
        for (const key of keysToRemove) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({ id: key, quantity: 0 }),
          }).catch(() => {});
        }
      }

      // 6) A blocked item was actually in the cart — reload so the mini-cart
      // badge/drawer and checkout button reflect the corrected cart right
      // away, regardless of which page the customer is currently on.
      if (blockedVariantIds.size > 0) {
        window.location.reload();
      }

    } catch (error) {
      console.warn('cleanupOrphansOnce error:', error);
    }
  }

  // Run on page load (and you can call again after cart updates). Deferred to
  // idle time so the (rare, non-empty-cart) fetch never competes with
  // render-critical work; falls back to a short timeout on browsers without
  // requestIdleCallback (e.g. Safari).
  function scheduleCleanupOrphansOnce() {
    if (window.requestIdleCallback) {
      requestIdleCallback(cleanupOrphansOnce, { timeout: 2000 });
    } else {
      setTimeout(cleanupOrphansOnce, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCleanupOrphansOnce);
  } else {
    scheduleCleanupOrphansOnce();
  }